const CORRECT_LOCATION_ORIGIN: string =
  process.env.NEXT_PUBLIC_CORRECT_LOCATION_ORIGIN || '';

export default CORRECT_LOCATION_ORIGIN;
